/**
 * EventsActions
 */

import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { IAction, IAppState } from '@app/store';
import {
  EntityId,
  IFilterQuery,
  IProcessedEvent,
  TRANSFER_TYPE,
} from '@shared/types';

/**
 * EventsActions
 * Defines the class for creating events actions
 */

@Injectable()
export class EventsActions {
  public static FETCH_EVENTS_LIST: string = 'FETCH_EVENTS_LIST';
  public static FETCH_EVENTS_LIST_SUCCESS: string = 'FETCH_EVENTS_LIST_SUCCESS';
  public static FETCH_EVENTS_LIST_ERROR: string = 'FETCH_EVENTS_LIST_ERROR';
  public static SAVE_EVENTS: string = 'SAVE_EVENTS';
  public static SAVE_SELECTED_EVENTS: string = 'SAVE_SELECTED_EVENTS';
  public static SAVE_SELECTED_EVENTS_BY_IDS: string =
    'SAVE_SELECTED_EVENTS_BY_IDS';
  public static SAVE_INCOMPLETE_TRANSFER_EVENTS: string =
    'SAVE_INCOMPLETE_TRANSFER_EVENTS';
  public static SAVE_TRANSFER_AUTO_POPULATE_EVENT: string =
    'SAVE_TRANSFER_POPULATE_EVENT';

  public static fetchEventsListAction(payload: IFilterQuery): IAction {
    return {
      payload,
      type: EventsActions.FETCH_EVENTS_LIST,
    };
  }

  public static fetchEventsListSuccessAction(
    payload: IProcessedEvent[],
  ): IAction {
    return {
      payload,
      type: EventsActions.FETCH_EVENTS_LIST_SUCCESS,
    };
  }

  public static fetchEventsListErrorAction(payload): IAction {
    return {
      payload,
      type: EventsActions.FETCH_EVENTS_LIST_ERROR,
    };
  }

  public static saveEventsAction(payload: IProcessedEvent[]): IAction {
    return {
      payload,
      type: EventsActions.SAVE_EVENTS,
    };
  }

  public static saveSelectedEventsAction(payload: IProcessedEvent[]): IAction {
    return {
      payload,
      type: EventsActions.SAVE_SELECTED_EVENTS,
    };
  }

  public static saveSelectedEventsByIdsAction(payload: string[]): IAction {
    return {
      payload,
      type: EventsActions.SAVE_SELECTED_EVENTS_BY_IDS,
    };
  }

  public static saveIncompleteTransferEventsAction(
    payload: IProcessedEvent,
  ): IAction {
    return {
      payload,
      type: EventsActions.SAVE_INCOMPLETE_TRANSFER_EVENTS,
    };
  }

  public static saveTransferAutoPopulateEventAction(
    eventId: EntityId,
    type: TRANSFER_TYPE,
  ): IAction {
    return {
      payload: {
        eventId,
        type,
      },
      type: EventsActions.SAVE_TRANSFER_AUTO_POPULATE_EVENT,
    };
  }

  public constructor(private ngRedux: NgRedux<IAppState>) {}

  public fetchEventsList(params: IFilterQuery): IAction {
    return this.ngRedux.dispatch(EventsActions.fetchEventsListAction(params));
  }

  public saveEvents(events: IProcessedEvent[]): IAction {
    return this.ngRedux.dispatch(EventsActions.saveEventsAction(events));
  }

  public saveSelectedEvents(events: IProcessedEvent[]): IAction {
    return this.ngRedux.dispatch(
      EventsActions.saveSelectedEventsAction(events),
    );
  }

  public saveSelectedEventsById(eventIds: string[]): IAction {
    return this.ngRedux.dispatch(
      EventsActions.saveSelectedEventsByIdsAction(eventIds),
    );
  }

  public saveIncompleteTransferEvents(event: IProcessedEvent): IAction {
    return this.ngRedux.dispatch(
      EventsActions.saveIncompleteTransferEventsAction(event),
    );
  }

  public saveTransferAutoPopulateEvent(
    eventId: EntityId,
    type: TRANSFER_TYPE,
  ): IAction {
    return this.ngRedux.dispatch(
      EventsActions.saveTransferAutoPopulateEventAction(eventId, type),
    );
  }
}
